import { init, onRouteChanged } from './src/analytics'

exports.onClientEntry = () => {
  init()
}

exports.onRouteUpdate = ({ location }) => {
  if (process.env.NODE_ENV === `production`) {
    onRouteChanged((location || {}).pathname)
  }
}



// WEBPACK FOOTER //
// ./plugins/my-analytics-plugin/gatsby-browser.js